

 export const enReferences = {
  our: "OUR",
  title: "REFERENCES",
  subTitle: "COLLABORATIONS THAT MAKE A DIFFERENCE",
  galleryAlt: "References gallery",
  description: "Our references showcase our valued clients and trusted partners who have collaborated with us. These partnerships demonstrate our commitment to building lasting professional relationships and delivering exceptional results.",
  reference_showcase_alt: "Our Clients and Partners Showcase"
};

export const frReferences = {
  our: "NOS",
  title: "RÉFÉRENCES",
  subTitle: "COLLABORATIONS QUI FONT LA DIFFÉRENCE",
  galleryAlt: "Galerie de références",
  description: "Nos références mettent en avant nos clients précieux et nos partenaires de confiance qui ont collaboré avec nous. Ces partenariats démontrent notre engagement à bâtir des relations professionnelles durables et à fournir des résultats exceptionnels.",
  reference_showcase_alt: "Vitrine de nos Clients et Partenaires"
};

export const nlReferences = {
  our: "ONZE",
  title: "REFERENTIES",
  subTitle: "SAMENWERKINGEN DIE HET VERSCHIL MAKEN",
  galleryAlt: "Referenties galerij",
  description: "Onze referenties tonen onze gewaardeerde klanten en vertrouwde partners die met ons hebben samengewerkt. Deze samenwerkingen tonen onze inzet voor het opbouwen van langdurige professionele relaties en het leveren van uitzonderlijke resultaten.",
  reference_showcase_alt: "Onze Klanten en Partners Showcase"
};

export const deReferences = {
  our: "UNSERE",
  title: "REFERENZEN",
  subTitle: "ZUSAMMENARBEITEN, DIE DEN UNTERSCHIED MACHEN",
  galleryAlt: "Referenzgalerie",
  description: "Unsere Referenzen zeigen unsere geschätzten Kunden und vertrauenswürdigen Partner, die mit uns zusammengearbeitet haben. Diese Partnerschaften zeigen unser Engagement für den Aufbau langfristiger Geschäftsbeziehungen und die Erzielung außergewöhnlicher Ergebnisse.",
  reference_showcase_alt: "Unsere Kunden- und Partner-Showcase"
};

